<div class="container mt-4">
  <div class="row">
    <div class="col-12">
      <!-- Page Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2>Responsive Design Demo</h2>
          <p class="text-muted mb-0">Test responsive layout components and utilities</p>
        </div>
        <div class="btn-group">
          <button class="btn btn-outline-info" (click)="simulateResize()">
            <i class="fas fa-expand-arrows-alt me-1"></i>
            Test Resize
          </button>
          <button class="btn btn-outline-warning" (click)="lockScroll()">
            <i class="fas fa-lock me-1"></i>
            Lock Scroll (3s)
          </button>
          <button class="btn btn-outline-success" (click)="exportLayoutInfo()">
            <i class="fas fa-download me-1"></i>
            Export Info
          </button>
        </div>
      </div>

      <!-- Screen Information Dashboard -->
      <div class="row mb-4">
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-primary">
            <div class="card-body">
              <i class="fas fa-desktop fa-2x text-primary mb-2"></i>
              <h5 class="text-primary">{{ getDeviceType() }}</h5>
              <p class="card-text">Device Type</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-info">
            <div class="card-body">
              <i class="fas fa-expand fa-2x text-info mb-2"></i>
              <h5 class="text-info">{{ currentScreenSize?.width }}x{{ currentScreenSize?.height }}</h5>
              <p class="card-text">Screen Size</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-success">
            <div class="card-body">
              <i class="fas fa-mobile-alt fa-2x text-success mb-2" 
                 [class.fa-tablet-alt]="currentScreenSize?.isTablet"
                 [class.fa-desktop]="currentScreenSize?.isDesktop"></i>
              <h5 class="text-success">{{ getBreakpointInfo().current | titlecase }}</h5>
              <p class="card-text">Breakpoint</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="card text-center border-warning">
            <div class="card-body">
              <i class="fas fa-2x text-warning mb-2" 
                 [class.fa-arrows-alt-v]="currentScreenSize?.orientation === 'portrait'"
                 [class.fa-arrows-alt-h]="currentScreenSize?.orientation === 'landscape'"></i>
              <h5 class="text-warning">{{ currentScreenSize?.orientation | titlecase }}</h5>
              <p class="card-text">Orientation</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Feature Detection -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-cogs me-2"></i>
                Device Capabilities & Preferences
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6" *ngFor="let feature of features">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-semibold">{{ feature.name }}:</span>
                    <span class="badge" [class.bg-success]="feature.check()" [class.bg-secondary]="!feature.check()">
                      {{ feature.check() ? 'Yes' : 'No' }}
                    </span>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <!-- Detailed Info -->
              <div class="row">
                <div class="col-md-4">
                  <h6>Device Pixel Ratio</h6>
                  <p class="text-muted">{{ currentScreenSize?.devicePixelRatio || 'N/A' }}</p>
                </div>
                <div class="col-md-4">
                  <h6>Viewport Height</h6>
                  <p class="text-muted">{{ getViewportInfo().height }}px</p>
                </div>
                <div class="col-md-4">
                  <h6>Safe Area</h6>
                  <p class="text-muted">
                    <small>
                      Top: {{ getSafeAreaInfo().top }}px, 
                      Bottom: {{ getSafeAreaInfo().bottom }}px
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Layout Configuration -->
      <div class="row mb-4">
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-sliders-h me-2"></i>
                Layout Configuration
              </h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <label class="form-label">Columns ({{ layoutConfig.columns }})</label>
                <input 
                  type="range" 
                  class="form-range" 
                  min="1" 
                  max="6" 
                  [value]="layoutConfig.columns"
                  (input)="updateColumns(+$any($event.target).value)">
              </div>
              
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Mobile Columns</label>
                    <select class="form-select form-select-sm" [(ngModel)]="layoutConfig.mobileColumns">
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Tablet Columns</label>
                    <select class="form-select form-select-sm" [(ngModel)]="layoutConfig.tabletColumns">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                    </select>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Gap</label>
                    <select class="form-select form-select-sm" [(ngModel)]="layoutConfig.gap">
                      <option value="0.5rem">Small</option>
                      <option value="1rem">Medium</option>
                      <option value="1.5rem">Large</option>
                      <option value="2rem">Extra Large</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Alignment</label>
                    <select class="form-select form-select-sm" [(ngModel)]="layoutConfig.alignItems">
                      <option value="start">Start</option>
                      <option value="center">Center</option>
                      <option value="end">End</option>
                      <option value="stretch">Stretch</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Responsive Classes Demo -->
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-code me-2"></i>
                Responsive Classes
              </h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <h6>Current Classes Applied:</h6>
                <div class="d-flex flex-wrap gap-2">
                  <span class="badge bg-primary" *ngFor="let cls of getResponsiveClasses()">
                    {{ cls }}
                  </span>
                </div>
              </div>
              
              <!-- Responsive Class Directive Demo -->
              <div class="mb-3">
                <h6>Directive Demo:</h6>
                <div 
                  appResponsiveClass="base-element"
                  mobileClass="mobile-specific"
                  tabletClass="tablet-specific" 
                  desktopClass="desktop-specific"
                  portraitClass="portrait-mode"
                  landscapeClass="landscape-mode"
                  class="demo-element p-3 border rounded">
                  
                  <i class="fas fa-magic me-2"></i>
                  This element adapts its classes based on screen size and orientation.
                  Check the developer tools to see the applied classes change when you resize the window.
                </div>
              </div>
              
              <!-- Media Query Tests -->
              <div class="mb-3">
                <h6>Media Query Tests:</h6>
                <div class="small">
                  <div class="d-flex justify-content-between">
                    <span>Max-width 768px:</span>
                    <span class="badge" [class.bg-success]="testMediaQuery('(max-width: 768px)')" [class.bg-secondary]="!testMediaQuery('(max-width: 768px)')">
                      {{ testMediaQuery('(max-width: 768px)') ? 'Match' : 'No Match' }}
                    </span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>Portrait orientation:</span>
                    <span class="badge" [class.bg-success]="testMediaQuery('(orientation: portrait)')" [class.bg-secondary]="!testMediaQuery('(orientation: portrait)')">
                      {{ testMediaQuery('(orientation: portrait)') ? 'Match' : 'No Match' }}
                    </span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>Touch device:</span>
                    <span class="badge" [class.bg-success]="testMediaQuery('(hover: none)')" [class.bg-secondary]="!testMediaQuery('(hover: none)')">
                      {{ testMediaQuery('(hover: none)') ? 'Match' : 'No Match' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Responsive Layout Demo -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-th me-2"></i>
                Responsive Layout Grid
              </h5>
            </div>
            <div class="card-body">
              <app-responsive-layout
                [mobileColumns]="layoutConfig.mobileColumns"
                [tabletColumns]="layoutConfig.tabletColumns"
                [desktopColumns]="layoutConfig.desktopColumns"
                [gap]="layoutConfig.gap"
                [alignItems]="layoutConfig.alignItems"
                [justifyContent]="layoutConfig.justifyContent">
                
                <div 
                  *ngFor="let item of demoItems; let i = index"
                  class="demo-item card h-100"
                  [class]="getItemClass(item.type)">
                  <div class="card-body d-flex flex-column">
                    <h6 class="card-title">
                      <i class="fas fa-cube me-2"></i>
                      {{ item.title }}
                    </h6>
                    <p class="card-text flex-grow-1">{{ item.description }}</p>
                    <div class="mt-auto">
                      <small class="opacity-75">
                        Item #{{ item.id }} • {{ item.type }}
                      </small>
                    </div>
                  </div>
                </div>
              </app-responsive-layout>
            </div>
          </div>
        </div>
      </div>

      <!-- Instructions and Tips -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-info-circle me-2"></i>
                Responsive Design Features
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <h6>Key Features</h6>
                  <ul class="mb-3">
                    <li><strong>Mobile-First:</strong> Optimized for mobile devices first</li>
                    <li><strong>Touch-Friendly:</strong> 44px minimum touch targets</li>
                    <li><strong>Flexible Grid:</strong> Automatic column adjustment</li>
                    <li><strong>Orientation Support:</strong> Portrait/landscape optimization</li>
                    <li><strong>Accessibility:</strong> Reduced motion & high contrast support</li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <h6>Testing Instructions</h6>
                  <ul class="mb-3">
                    <li>Resize your browser window to see breakpoint changes</li>
                    <li>Use browser dev tools to simulate different devices</li>
                    <li>Try landscape/portrait orientations on mobile</li>
                    <li>Test with touch simulation in dev tools</li>
                    <li>Adjust layout settings and observe changes</li>
                  </ul>
                </div>
              </div>
              
              <div class="alert alert-info">
                <i class="fas fa-lightbulb me-2"></i>
                <strong>Tip:</strong> All responsive components in this system automatically adapt to screen size 
                and device capabilities. The responsive service provides utilities for custom responsive behavior.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>